export const CheckCircleIcon = () => (
  <svg width="20" height="20" viewBox="2 2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
      fill="#303030"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7337 8.29289C17.0888 8.68342 17.0888 9.31658 16.7337 9.70711L11.2792 15.7071C10.9242 16.0976 10.3486 16.0976 9.99354 15.7071L7.26627 12.7071C6.91124 12.3166 6.91124 11.6834 7.26627 11.2929C7.62129 10.9024 8.19689 10.9024 8.55192 11.2929L10.6364 13.5858L15.4481 8.29289C15.8031 7.90237 16.3787 7.90237 16.7337 8.29289Z"
      fill="white"
    />
  </svg>
);
